const mapSubItem = (subItem = {}) => {
    const { link = '', pathname = '' } = subItem;
    return {
        link,
        pathname,
    };
};

const mapSubmenuItem = (submenu = {}) => {
    const { link = '', pathname = '', subNavLink = [] } = submenu;
    const submenuObject = {
        link,
        pathname,
        hasValidPath: pathname && pathname.trim() !== '',
    };

    if (subNavLink?.length > 0) {
        submenuObject.items = subNavLink.map(mapSubItem);
    }

    return submenuObject;
};

// Maps navigation link data from Builder.io to match the structure of CORPORATE_MENU.
// This ensures dynamic navigation links render correctly in the Header component.
const mapNavigationLinks = (navigationLinks = []) => {
    return navigationLinks.map((item) => {
        const { link = '', pathname = '', navLink = [] } = item?.data ?? {};
        return {
            link,
            pathname,
            hasValidPath: pathname && pathname.trim() !== '',
            items: navLink.map(mapSubmenuItem),
        };
    });
};

export default mapNavigationLinks;
